@if (mainFormGroup) {
    <div class="card">
        <div class="card-body" [formGroup]="mainFormGroup">
            <h5 class="card-title">{{ 'export.kri.cardTitle' | transloco }}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ 'export.selectExportTypeBelow' | transloco }}</h6>

            <div class="form-group">
                <label>{{ 'export.kri.startDate' | transloco }}</label>
                <date-input
                    #startDateComponent
                    formControlName="startDate"
                    [maxDate]="endDate"
                ></date-input>
            </div>

            <div class="form-group">
                <label>{{ 'export.kri.endDate' | transloco }}</label>
                <date-input
                    #endDateComponent
                    formControlName="endDate"
                    [minDate]="startDate"
                ></date-input>
            </div>
            <hr />
            <button class="btn btn-default me-2 mb-2" (click)="exportKriDataPoints()">
                {{ 'export.kri.exportButton' | transloco }}
            </button>
        </div>
    </div>
}
